import { render, staticRenderFns } from "./AdmissionFormLinkEmailCopy.vue?vue&type=template&id=372b3c60"
import script from "./AdmissionFormLinkEmailCopy.vue?vue&type=script&lang=js"
export * from "./AdmissionFormLinkEmailCopy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports